<div class="col card card-custom  d-flex">
    <div class="card-header ">
        <div class="dashboard-filter-wrapper d-flex justify-content-between w-100">
            <div class="card-title align-items-start flex-column dashboard-tile-title">
                <span class="card-label fw-semibold">
                    <span translate="TRANSLATE.PARTNER_DASHBOARD_TOP_FIVE_PRODUCTS_TILE_INTRO_TITLE">
                        <span class="text-gray-500 pt-1 fw-semibold fs-6 ms-1" translate="TRANSLATE.PARTNER_DASHBOARD_TOP_FIVE_PRODUCTS_BY_RENEWAL_DATE_TILE_INTRO_TITLE">

                        </span>
                    </span>

                </span>
            </div>
            <div class="d-flex align-items-center gap-lg-4">
                <div class="card-toolbar dashboard-filter">

                </div>
                @if(!!productsData && productsData.length>0){
                <div ngbDropdown class="d-flex align-items-center" placement="bottom-right">
                    <button class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary remove-caret d-flex flex-column" style="padding: 10px; width: auto;" id="dropdownToggle" ngbDropdownToggle>
                        <app-keenicon name="category" class="fs-2" style="display: contents;"><span class="fs-2 ki-category ki-duotone"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><!----></span><!----><!----></app-keenicon> </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownToggle" class="dorpdown-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base">
                        <div class='menu-item my-0' ngbDropdownItem>
                            <div class="apexcharts-menu-item" (click)="generatePNG()"><span translate="TRANSLATE.DASHBOARD_CARD_ACTIONS_OPTION_TEXT_DOWNLOAD_PNG"></span></div>
                        </div>
                        <div class='menu-item my-0' ngbDropdownItem>
                            <div class="apexcharts-menu-item" (click)="generateSVG()"><span translate="TRANSLATE.DASHBOARD_CARD_ACTIONS_OPTION_TEXT_DOWNLOAD_SVG"></span></div>
                        </div>
                    </div>
                </div>
                }

            </div>


        </div>
    </div>
    <div class="card-body pt-2 pb-2s" style="height:350px" id="five-products-by-revenue-png1">
        @if(!!isLoading){
        <app-loader></app-loader>
        }
        @else if(!!productsData && productsData.length>0){
        <div class="pt-2"  style="height:310px; overflow: auto;">
            @for(product of productsData; track $index){
            <div class="d-flex flex-wrap align-items-center gap-lg-4 my-4">
                <div class="symbol-box flex-shrink-0 mr-4">
                    <span class="symbol-label font-size-sm font-size-lg">{{product?.ProductName | formatforinitials
                        }}</span>
                </div>
                <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3" style="width: 10px;">
                    <span class="text-gray-800  fs-6 fw-semibold product-name overflow-ellipsis" ngbTooltip="{{product?.ProductName}}" placement="top-start">
                        {{product?.ProductName}}
                    </span>
                </div>
                <div class="d-flex align-items-center py-lg-0 py-2 mr-10">
                    <div class="d-flex flex-column text-right">
                        <span class="text-gray-800  fs-6 fw-semibold" style="text-align: end;">
                            <span translate="TRANSLATE.CUSTOMER_SUBSCRIPTION_RENEWAL_CONSENT_RENEWAL_DATE_TEXT"></span>
                        </span>
                        <!-- dont remove the inline css , this is to fix a letterspacing issue in html2canvas-->
                        <span class="text-gray-800  fs-6 fw-semibold" style="text-align: end;letter-spacing: -0.85px; word-spacing: 0.01px !important; font-size:1.075rem !important">
                            {{product?.ProviderEffectiveEndDate | c3Date}}
                        </span>
                    </div>
                </div>
            </div>
            }
        </div>
        }
        @else if(productsData.length<1 && !isLoading){ <div class="d-flex align-items-center justify-content-center" style="height: 100%;">
            <div class="row">
                <div class="col-md-12">
                    <app-common-no-record></app-common-no-record>
                </div>
            </div>
    </div>
    }
</div>
</div>